const BASE = "https://support.gs-group.fr/api";
const token = () => localStorage.getItem("nexo_token");
const h = () => ({
  "Content-Type": "application/json",
  Authorization: "Bearer " + token()
});

export const api = {
  login: (email, password) =>
    fetch(BASE + "/auth/login", { method:"POST", headers:h(), body:JSON.stringify({email,password}) }).then(r=>r.json()),
  me: () => fetch(BASE + "/auth/me", { headers:h() }).then(r=>r.json()),
  getInterventions: () => fetch(BASE + "/interventions", { headers:h() }).then(r=>r.json()),
  createIntervention: (data) =>
    fetch(BASE + "/interventions", { method:"POST", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  updateStatut: (id, statut) =>
    fetch(BASE + "/interventions/" + id + "/statut", { method:"PATCH", headers:h(), body:JSON.stringify({statut}) }).then(r=>r.json()),
  getTechniciens: () => fetch(BASE + "/users/techniciens", { headers:h() }).then(r=>r.json()),
  getClients: () => fetch(BASE + "/clients", { headers:h() }).then(r=>r.json()),
  createClient: (data) =>
    fetch(BASE + "/clients", { method:"POST", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  updateClient: (id, data) =>
    fetch(BASE + "/clients/" + id, { method:"PATCH", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  getTickets: () => fetch(BASE + "/tickets", { headers:h() }).then(r=>r.json()),
  createTicket: (data) =>
    fetch(BASE + "/tickets", { method:"POST", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  assignTicket: (id, technicien_id) =>
    fetch(BASE + "/tickets/" + id + "/assigner", { method:"PATCH", headers:h(), body:JSON.stringify({technicien_id}) }).then(r=>r.json()),
  getStock: () => fetch(BASE + "/stock", { headers:h() }).then(r=>r.json()),
  addProduit: (data) =>
    fetch(BASE + "/stock", { method:"POST", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  updateQuantite: (id, quantite) =>
    fetch(BASE + "/stock/" + id + "/quantite", { method:"PATCH", headers:h(), body:JSON.stringify({quantite}) }).then(r=>r.json()),
};

export const usersApi = {
  getAll: () => fetch(BASE + "/users", { headers:h() }).then(r=>r.json()),
  create: (data) =>
    fetch(BASE + "/users", { method:"POST", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  update: (id, data) =>
    fetch(BASE + "/users/" + id, { method:"PATCH", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
  changePassword: (id, password) =>
    fetch(BASE + "/users/" + id + "/password", { method:"PATCH", headers:h(), body:JSON.stringify({password}) }).then(r=>r.json()),
  deactivate: (id) =>
    fetch(BASE + "/users/" + id, { method:"DELETE", headers:h() }).then(r=>r.json()),
};

export const modelesApi = {
  getAll: () => fetch(BASE + "/modeles", { headers:h() }).then(r=>r.json()),
  getRapport: (intervention_id) =>
    fetch(BASE + "/modeles/rapport/" + intervention_id, { headers:h() }).then(r=>r.json()),
  saveRapport: (data) =>
    fetch(BASE + "/modeles/rapport", { method:"POST", headers:h(), body:JSON.stringify(data) }).then(r=>r.json()),
};
